<table *ngIf="signatures?.length" class="ir-plugin-table" style="margin-bottom: 10px">
  <tr>
    <td>
      <span>
        <strong>{{ 'plugins.installationsignature.type' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationsignature.name-label' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationsignature.function' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationsignature.place' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationsignature.date' | translate }}</strong>
      </span>
    </td>
    <td>
      <span>
        <strong>{{ 'plugins.installationsignature.signature' | translate }}</strong>
      </span>
    </td>
  </tr>

  <tr *ngFor="let signature of signatures">
    <td>
      <p>
        <span>{{ signature.Type | signaturetype }}</span>
      </p>
    </td>
    <td>
      <p>
        <span>{{ signature?.FirstName }} {{ signature?.LastName }}</span>
      </p>
    </td>
    <td>
      <p>
        <span>{{ signature.JobFunction }}</span>
      </p>
    </td>
    <td>
      <p>
        <span>{{ signature.Place }}</span>
      </p>
    </td>
    <td>
      <p>
        <span>{{ signature.DateValue | formatDate }}</span>
      </p>
    </td>
    <td>
      <img
        style="width: 200px; background-color: #fff"
        *ngIf="signature.SignatureImage"
        [src]="signature.SignatureImage"
      />
    </td>
  </tr>
</table>
